import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const [selectedCat, setSelectedCat] = useState("");

  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Soft%20artistic%20abstract%20composition%20with%20dusty%20rose%20and%20warm%20sand%20gradients%2C%20gentle%20layered%20textures%20with%20subtle%20watercolor%20washes%2C%20minimal%20modern%20European%20editorial%20backdrop%2C%20soft%20diffused%20light%2C%20delicate%20translucent%20overlays%2C%20elegant%20warm%20undertones%2C%20airy%20aesthetic%20magazine%20quality&width=1600&height=900&seq=kakobuy-hero-mood-02&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 flex flex-col flex-1 pt-24 pb-0">
        <div className="flex-1 flex flex-col justify-center w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
            <div className="lg:w-3/5">
              <div className="inline-flex items-center gap-2 bg-background-50/60 backdrop-blur-md rounded-full px-4 py-2 mb-8 border border-background-200/50">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line text-sm text-foreground-700"></i>
                </div>
                <select
                  className="appearance-none bg-transparent text-sm font-medium text-foreground-800 cursor-pointer pr-2 focus:outline-none"
                  value={selectedCat}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSelectedCat(val);
                    if (val) {
                      window.open(val, "_blank", "noopener,nofollow");
                      setSelectedCat("");
                    }
                  }}
                >
                  <option value="" disabled>
                    Wybierz kategorię produktów
                  </option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.url}>
                      {cat.namePl} — {cat.nameEn}
                    </option>
                  ))}
                </select>
              </div>

              <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
                Kakobuy
                <br />
                Spreadsheet
                <br />
                <span className="italic font-normal">Polska 2026</span>
              </h1>
            </div>

            <div className="lg:w-2/5 flex flex-col justify-center gap-6">
              <p className="text-base md:text-lg text-background-50/90 leading-relaxed max-w-md">
                Najlepszy arkusz produktów do zamawiania butów, ubrań, elektroniki i akcesoriów z Chin. Sprawdź
                zweryfikowane linki i zacznij oszczędzać na zakupach.
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="bg-foreground-900 text-background-50 px-7 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-foreground-900/20"
                >
                  kakobuy spreadsheet
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm font-medium text-background-50/90 hover:text-background-50 border-b border-background-50/50 hover:border-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer pb-0.5"
                >
                  buy it now
                  <i className="ri-arrow-right-up-line ml-1 text-xs align-middle"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-10 md:mt-16 px-4 md:px-6 max-w-7xl mx-auto pb-8">
          <div className="w-full h-48 md:h-72 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Curated%20fashion%20flat%20lay%20with%20stylish%20sneakers%20denim%20jacket%20sunglasses%20and%20watch%20on%20light%20terracotta%20surface%2C%20soft%20morning%20natural%20lighting%2C%20editorial%20product%20photography%2C%20modern%20European%20lifestyle%20aesthetic%2C%20warm%20earthy%20tones%2C%20clean%20artistic%20arrangement%2C%20subtle%20organic%20shadows&width=1600&height=600&seq=kakobuy-hero-flatlay-02&orientation=landscape"
              alt="Kakobuy Spreadsheet - produkty"
              title="Kakobuy Spreadsheet - kolekcja produktów"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}